import React, { FC, useState, useEffect } from 'react';
import { Question } from '../models/Question';
import './QuestionResultCard.css';

interface QuestionResultCardProps {
    index: number
    data: Question
    userAnswer: number
}

enum QuestionStatus {
    CORRECT = 'CORRECT',
    INCORRECT = 'INCORRECT',
    UNANSWERED = 'UNANSWERED',
  }

const QuestionResultCard: FC<QuestionResultCardProps> = ({ index, data, userAnswer }) => {
    const [questionStatus, setQuestionStatus] = useState<QuestionStatus>(QuestionStatus.UNANSWERED);

    useEffect(() => {
        setQuestionStatus(getQuestionStatus())
    }, []);

    const getQuestionStatus = () => {
        if (userAnswer === -1) {
            return QuestionStatus.UNANSWERED;
        }

        if (userAnswer === data.answer) {
            return QuestionStatus.CORRECT;
        }

        return QuestionStatus.INCORRECT;
    }

    const getOptionClass = (optionId: number) => {
        const isCorrect = data.answer === optionId;
        const isSelected = userAnswer === optionId;
        
        if (isCorrect && isSelected) {
            return 'correct-selected';
        }
        if (isCorrect && !isSelected) {
            return 'correct-not-selected';
        }
        if (!isCorrect && isSelected) {
            return 'incorrect-selected';
        }
        return 'neutral';
    }

    const getStatusLabel = () => {
        switch (questionStatus) {
            case QuestionStatus.CORRECT:
                return 'Korrekt';
            case QuestionStatus.INCORRECT:
                return 'Forkert';
            case QuestionStatus.UNANSWERED:
                return 'Ikke besvaret';
            default:
                return '';
        }
    }

    const getStatusClass = () => {
        switch (questionStatus) {
            case QuestionStatus.CORRECT:
                return 'status-correct';
            case QuestionStatus.INCORRECT:
                return 'status-incorrect';
            case QuestionStatus.UNANSWERED:
                return 'status-unanswered';
            default:
                return '';
        }
    }

    return (
        <div className="question-result-card">
            <div className="question-result-card-body">
                <div className="question-result-header">
                    <div className="question-result-title">
                        <span className="question-number">Spørgsmål {index + 1}.</span> {data.text}
                    </div>
                    <div className={`question-status-badge ${getStatusClass()}`}>
                        {getStatusLabel()}
                    </div>
                </div>
                <div className="question-result-options">
                    {data.options.map((option, i) => (
                        <div
                            key={i}
                            className={`question-result-option ${getOptionClass(option.id)}`}
                        >
                            {option.text}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default QuestionResultCard;
